import { SvgIcon, SvgIconProps } from '@mui/material';

export function AnimalsIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props}>
      <svg
        width="24"
        height="25"
        viewBox="0 0 24 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g id="u:animals-icon">
          <g id="Vector">
            <path
              d="M2.14093 8.99665C2.75904 6.53422 7.13158 2.66212 8.06509 2.99083C8.41936 3.23158 8.26339 4.10075 7.91091 5.25713C7.55844 6.41351 7.14295 9.22517 6.87185 10.6356C6.60075 12.046 6.1066 13.2712 4.57745 13.1676C3.04829 13.0641 1.52281 11.4591 2.14093 8.99665Z"
              fill="currentcolor"
            />
            <path
              d="M12.8313 11.637C13.4494 9.17455 11.4396 3.63383 10.4663 3.46398C10.0422 3.50124 9.76948 4.33989 9.53375 5.52679C9.29802 6.71369 8.33771 9.38291 7.91094 10.7526C7.48417 12.1224 7.34027 13.4391 8.72985 14.0986C10.1194 14.7582 12.2132 14.0994 12.8313 11.637Z"
              fill="currentcolor"
            />
            <path
              d="M11.3658 17.4753C11.9839 15.0129 16.3564 11.1408 17.2899 11.4695C17.6442 11.7102 17.4882 12.5794 17.1357 13.7358C16.7833 14.8922 16.3678 17.7038 16.0967 19.1143C15.8256 20.5247 15.3314 21.7498 13.8023 21.6463C12.2731 21.5428 10.7476 19.9377 11.3658 17.4753Z"
              fill="currentcolor"
            />
            <path
              d="M21.8841 20.2692C22.5022 17.8067 20.4925 12.266 19.5191 12.0962C19.095 12.1334 18.8223 12.9721 18.5866 14.159C18.3509 15.3459 17.3905 18.0151 16.9638 19.3848C16.537 20.7546 16.3931 22.0713 17.7827 22.7308C19.1723 23.3904 21.266 22.7316 21.8841 20.2692Z"
              fill="currentcolor"
            />
          </g>
        </g>
      </svg>
    </SvgIcon>
  );
}
